import { ButtonWithDemoExitConfirmation } from '../../../components/DemoExitConfirmation';
import { MiniTrialGuideButton } from './MiniTrialGuideButton';
import { useMiniTrialGuide } from '../../../components/GlobalToolbar/hooks/useMiniTrialGuide';
import { jsx as _jsx } from "react/jsx-runtime";
export const MiniTrialGuideContainer = () => {
  const shouldRender = useMiniTrialGuide();
  if (!shouldRender) {
    return null;
  }
  return /*#__PURE__*/_jsx(ButtonWithDemoExitConfirmation, {
    component: MiniTrialGuideButton,
    itemName: "Mini Trial Guide Button"
  });
};